import Vue from "vue";
import {Commit, Getter} from "vuex";
import EventWaiverModel, { EventWaiverData, create as createWaiver } from "../../models/EventWaiverModel";
import ApiService from "../../lib/api";

interface EntryWaiversState {
  waivers: Record<string, EventWaiverModel>
}

interface EntryWaiverPayload {
   entry_ref: string;
   waiver: EventWaiverModel;
}

const state: EntryWaiversState = {
  waivers: {}
};

const mutations = {
  add(store: EntryWaiversState, payload: EntryWaiverPayload): void {
    store.waivers[payload.entry_ref] = payload.waiver;
  }
};

const actions = {
  add({commit}: {commit: Commit}, payload: EntryWaiverPayload): Promise<void> {
    return new Promise((resolve) => {
      commit('add', payload);
      resolve();
    });
  },
  save({commit, getters}: {commit: Commit, getters: any}, entry_ref: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const waiver = getters.byEntry(entry_ref);
      const action = waiver.data.id ? 'patch' : 'post';

      ApiService[action]('/events/waivers/' + entry_ref, waiver.data).then((resp: ApiResponseSingle<EventWaiverData>) => {
        commit('add', createWaiver(resp.data));
        resolve();
      }).catch((jXHR: JQueryXHR) => {
        reject(jXHR.responseJSON.errors[0].message);
      });
    });
  }
};

const getters = {
  byEntry: (state: EntryWaiversState) => (ref: string) => {
    return state.waivers[ref];
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
